<template>
    <div>
        <el-row>
            <el-col :span="12" :offset="6">
                <!-- 走马灯-文字类型 -->
                <!--
                 参数：
                 height：高度
                 initialIndex：初始状态激活的幻灯片的索引，默认从 0 开始
                 trigger：指示器的触发方式,可选值 click
                 autoplay：是否自动切换
                 interval：自动切换的时间间隔，单位为毫秒（3000）
                 indicatorPosition：指示器的位置outside/none
                 arrow： 切换箭头的显示时机 可选值always/hover/never
                 type：走马灯的类型 可选值card
                 loop：是否循环显示
                 方法：
                 change
              -->
                <td-carousel
                    :listInfo="listInfo"
                    height="300px"
                    :initialIndex="0"
                    trigger="click"
                    :autoplay="true"
                    :interval="3000"
                    indicatorPosition="outside"
                    arrow="always"
                    type=""
                    :loop="true"
                    @change="carouselChange"
                ></td-carousel>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12" :offset="6">
                <!-- 走马灯-图片类型 -->
                <td-carousel :listInfo="listInfoImg" type="card"></td-carousel>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {
            listInfo: ['客户为纲，技术为本，奋斗为荣，做天地建设者', '目标、执行、勤奋、团队', '及时提供有竞争力的产品', '行业做强，产业做大'],
            listInfoImg: [
                {
                    src: '../../../static/image/dog.png'
                },
                {
                    src: '../../../static/image/dog.png'
                },
                {
                    src: '../../../static/image/dog.png'
                }
            ]
        };
    },
    methods: {
        /* 走马灯回调 */
        carouselChange(currentIndex, OldIndex) {}
    }
};
</script>
